<ion-content class="conference-page-content">
  <ion-header>
    <app-header [backRoute]="['/home']"></app-header>
  </ion-header>
  <div class="results-page">

    <div class="title" [@enter] *ngIf="false">
      <div class="text my-color-blue">{{ 'Conference Results | translate ' }}</div>
    </div>

    <ion-slides [options]="slideOpts">
      <ng-container *ngIf="isResultsActive">
        <ion-slide *ngFor="let card of cards; let i = index">
          <app-card [card]="card"
                    [isResults]="isResultsActive"
                    [isWordCloudReady]="isWordCloudReady"
          ></app-card>
        </ion-slide>
      </ng-container>
    </ion-slides>
  </div>
</ion-content>
